export default __webpack_public_path__ + "static/media/DestinationsMainPage.b3b0652b.jpg";